import { render } from "./RolesManagementTabView.vue?vue&type=template&id=c09d1164&ts=true"
import script from "./RolesManagementTabView.vue?vue&type=script&lang=ts"
export * from "./RolesManagementTabView.vue?vue&type=script&lang=ts"

import "./RolesManagementTabView.vue?vue&type=style&index=0&id=c09d1164&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__